import { Link } from 'react-router-dom';

interface CategoryOverviewProps {
  categories: Array<{
    slug: string;
    name: string;
    description: string;
    icon: string;
    count: number;
  }>;
}

export default function CategoryOverview({ categories }: CategoryOverviewProps) {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 tracking-wide">
            内容分类
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            从训练到饮食，从体型到心态，全方位覆盖猛男蜕变的每一个维度
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 md:p-6 hover:bg-primary-50/60 transition-colors cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 line-clamp-2">
                {cat.description}
              </p>
              <p className="mt-3 text-xs text-foreground-400">
                {cat.count} 篇文章
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}